exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3gUubwRZDWaOF0{align-items:center;box-sizing:border-box;display:flex;height:100vh;justify-content:center;overflow:auto;width:100vw}._1URVGCiHsrWlwF{background:rgba(0,0,0,.6)}._2WhIqhRFBTG7Ry{background:rgba(0,0,0,.75)}._1rhhEuk7pUqNV_{background:transparent;position:relative;top:44px;margin-bottom:80px}._1rhhEuk7pUqNV_:focus{outline:none}", ""]);

// exports
exports.locals = {
	"overlay": "_3gUubwRZDWaOF0",
	"light": "_1URVGCiHsrWlwF",
	"dark": "_2WhIqhRFBTG7Ry",
	"contents": "_1rhhEuk7pUqNV_"
};